import { AppButton } from '../../components/form';
import { AppPageHeader } from 'components/ui';
import { observer } from 'mobx-react-lite';
import { t } from 'utilities/TranslationUtils';
import { useEffect } from 'react';

export const AppRedirectPage = observer(() => {
  // Below, has been copied from the old project
  useEffect(() => {
    var meta = document.createElement('meta');
    meta.name = 'robots';
    meta.setAttribute('content', 'noindex');
    document.getElementsByTagName('head')[0].appendChild(meta);
  }, []);

  return (
    <div>
      <AppPageHeader title={t('common.app_redirect_title')} />
      <AppButton className='mt-3' onClick={() => (window.location.href = window.location.href.toString())}>
        {t('common.app_redirect_page_open')}
      </AppButton>
    </div>
  );
});

export default AppRedirectPage;
